/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Too_LargeInputs */

const en_document_too_large = /** @type {(inputs: Document_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File too large. Maximum 25 MB.`)
};

const id_document_too_large = /** @type {(inputs: Document_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File terlalu besar. Maksimal 25 MB.`)
};

/** @type {(inputs: Document_Too_LargeInputs) => LocalizedString} */
const es_document_too_large = en_document_too_large;

/** @type {(inputs: Document_Too_LargeInputs) => LocalizedString} */
const fr_document_too_large = en_document_too_large;

/** @type {(inputs: Document_Too_LargeInputs) => LocalizedString} */
const de_document_too_large = en_document_too_large;

/** @type {(inputs: Document_Too_LargeInputs) => LocalizedString} */
const ja_document_too_large = en_document_too_large;

/** @type {(inputs: Document_Too_LargeInputs) => LocalizedString} */
const zh_document_too_large = en_document_too_large;

/** @type {(inputs: Document_Too_LargeInputs) => LocalizedString} */
const ar_document_too_large = en_document_too_large;

/** @type {(inputs: Document_Too_LargeInputs) => LocalizedString} */
const it_document_too_large = en_document_too_large;

/** @type {(inputs: Document_Too_LargeInputs) => LocalizedString} */
const ru_document_too_large = en_document_too_large;

/** @type {(inputs: Document_Too_LargeInputs) => LocalizedString} */
const pt_document_too_large = en_document_too_large;

/** @type {(inputs: Document_Too_LargeInputs) => LocalizedString} */
const ko_document_too_large = en_document_too_large;

/**
* | output |
* | --- |
* | "File too large. Maximum 25 MB." |
*
* @param {Document_Too_LargeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_too_large = /** @type {((inputs?: Document_Too_LargeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Too_LargeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_too_large(inputs)
	if (locale === "es") return es_document_too_large(inputs)
	if (locale === "fr") return fr_document_too_large(inputs)
	if (locale === "de") return de_document_too_large(inputs)
	if (locale === "ja") return ja_document_too_large(inputs)
	if (locale === "zh") return zh_document_too_large(inputs)
	if (locale === "ar") return ar_document_too_large(inputs)
	if (locale === "id") return id_document_too_large(inputs)
	if (locale === "it") return it_document_too_large(inputs)
	if (locale === "ru") return ru_document_too_large(inputs)
	if (locale === "pt") return pt_document_too_large(inputs)
	return ko_document_too_large(inputs)
});